class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    document.addEventListener('click', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector(event) {
    event.stopPropagation();
    this.elements.panel.toggleAttribute('hidden');
    const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.button.setAttribute('aria-expanded', (!expanded).toString());
  }

  closeSelector(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }
}

class LocalizationForm487 extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.country-selector-toggle');
    this.list = this.querySelector('.country-selector-list');
    this.toggle.addEventListener('click', () => this.onToggle());
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }
  onToggle() {
    const open = this.list.classList.toggle('open');
    this.toggle.setAttribute('aria-expanded', open);
    this.toggle.querySelector('svg').classList.toggle('rotate-180', open);
  }
  close() {
    this.list.classList.remove('open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.querySelector('svg').classList.remove('rotate-180');
  }
}
customElements.define('localization-form-487', LocalizationForm487);

customElements.define('localization-form', LocalizationForm);